



































































import BaseComponent from '@/core/base.component';
import { Component, Vue } from 'vue-property-decorator';
import TableWithTitle from '@/modules/_common/components/TableWithTitle.vue';
import companyDistrictService from '@/services/company-district.service';
import { CompanyDistrictDto } from '@/dto/company-district/company-district.dto';
import { CompanyDistrictSearchDto } from '@/dto/company-district/company-district-search.dto';
import CommonTable from '@/modules/_common/components/CommonTable.vue';
import { Pagination } from '@/core';
import { CodeManagementDto } from '@/services/init/dto';
import codeManagementService from '@/services/init/code-management.service';

@Component({ name: 'District', components: { CommonTable } })
export default class District extends BaseComponent {
  private companyDistrictDtoList: CompanyDistrictDto[] = [];
  private companyDistrictSearchDto = new CompanyDistrictSearchDto();
  private pagination = new Pagination();
  private dataLoading = false;
  private companyDistrictListCount = null;
  private accountStatusSelect: CodeManagementDto[] = [];

  private headers = [
    {
      text: '지점명',
      value: 'nameKr',
      align: 'center',
    },
    {
      text: '주소',
      value: 'address',
      align: 'center',
    },
    {
      text: '상태',
      value: 'codeManagement.value',
      align: 'center',
    },
  ];

  toSelectedItemPage(value) {
    this.$router.push(`/company/district/${value.no}`);
  }

  getAccountStatus() {
    codeManagementService.findAccountStatus().subscribe(res => {
      if (res) {
        this.accountStatusSelect = res.data;
      }
    });
  }

  getList() {
    this.dataLoading = true;
    companyDistrictService
      .findAll(this.companyDistrictSearchDto, this.pagination)
      .subscribe(res => {
        this.dataLoading = false;
        this.companyDistrictDtoList = res.data.items;
        this.companyDistrictListCount = res.data.totalCount;
      });
  }

  reset() {
    this.companyDistrictSearchDto = new CompanyDistrictSearchDto();
    this.getList();
  }
  created() {
    this.getList();
    this.getAccountStatus();
  }
  activated() {
    this.getList();
  }
}
